module.exports = __webpack_public_path__ + "img/61.a191a515.jpg";